import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11.154 22.083c0 .507-.411.917-.917.917H5.654a4.59 4.59 0 0 1-4.584-4.584V5.584A4.59 4.59 0 0 1 5.653 1h9.167a4.59 4.59 0 0 1 4.583 4.582v1.834a.916.916 0 1 1-1.833 0V5.582a2.753 2.753 0 0 0-2.75-2.75H5.653a2.754 2.754 0 0 0-2.75 2.751v12.832a2.753 2.753 0 0 0 2.75 2.75h4.583c.506 0 .917.41.917.917m11.506.507a.914.914 0 0 1-1.296 0l-2.444-2.444a5.47 5.47 0 0 1-3.183 1.02 5.5 5.5 0 1 1 5.5-5.5 5.47 5.47 0 0 1-1.02 3.184l2.443 2.444a.916.916 0 0 1 0 1.296m-6.025-4.792 2.478-2.396a.917.917 0 1 0-1.27-1.322l-2.487 2.405a.34.34 0 0 1-.478 0l-1.038-1.016a.917.917 0 0 0-1.282 1.311l1.038 1.016c.42.411.973.617 1.525.617s1.1-.206 1.515-.615M7.487 5.583H5.654a.916.916 0 1 0 0 1.833h1.833a.916.916 0 1 0 0-1.833m0 9.167H5.654a.916.916 0 1 0 0 1.833h1.833a.916.916 0 1 0 0-1.833m3.667-9.167a.916.916 0 1 0 0 1.833h3.666a.916.916 0 1 0 0-1.833zm-3.667 4.583H5.654a.916.916 0 1 0 0 1.834h1.833a.916.916 0 1 0 0-1.834"
    }, null, -1)
  ]))]))
}
export default { render: render }